module.exports = __webpack_public_path__ + "static/media/SheJiao1.f4759064.png";